var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShare = function SvgShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "15px",
    viewBox: "0 0 14 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-523.000000, -376.000000)",
    fill: "#1DBADF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 171.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(421.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(101.000000, 131.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.1568186,1 C1.9622767,1 1,1.96564058 1,3.1568186 L1,12.8431814 C1,14.0377233 1.96564058,15 3.1568186,15 L12.8431814,15 C14.0377233,15 15,14.0343594 15,12.8431814 L15,3.1568186 C15,1.9622767 14.0343594,1 12.8431814,1 L10.8361965,0.989378879 L11.9973755,2.55432028 L12.4250488,2.56494141 C13.0228814,2.56494141 13.4924927,3.07120376 13.4924927,3.66955566 L13.547669,12.4434199 C13.547669,13.0412525 13.0661253,13.5233154 12.4677734,13.5233154 L3.68408253,13.4879756 C3.08624996,13.4879756 2.60418701,13.006432 2.60418701,12.4080801 L2.54901073,3.63421581 C2.54901073,3.03638323 3.03055434,2.55432028 3.62890625,2.55432028 L4.04199219,2.56494141 L5.12486307,1.01062112 L3.1568186,1 Z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75,9.5 L8.75,5 L7.25,5 L7.25,9.5 L5.5,9.5 L5.51239014,11.010376 L10.5123901,11.010376 L10.5,9.5 L8.75,9.5 Z M8,0 L11.0293579,5 L5.02935791,5 L8,0 Z",
    fillRule: "evenodd"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/share.8511174f.svg";
export { ForwardRef as ReactComponent };